<div class="modal-header">
    <h4 class="modal-title">Artes - <strong>{{ data.family }}</strong> - Historial </h4>
    <button type="button" class="btn-close" (click)="close()" aria-label="Cerrar"></button></div>
<mat-dialog-content>
    <div class="modal-body">
        <!-- <div class="d-flex justify-content-between align-items-center pb-4">
            <h6 class="mb-0">
                    <span>Sube un nuevo archivo de artes:</span>
            </h6>
            <mat-slide-toggle *ngIf="data.toggleEnfocus == 1" class="custom-toggle" (change)="onToggleChange($event)">Omitir Validación Enfocus</mat-slide-toggle>
        </div>


        <form [formGroup]="form">
            <ngx-file-drag-drop class="ngx-file_f" emptyPlaceholder="Arrastre o seleccione archivos" formControlName="blob" [formControl]="fileControl" (valueChanged)="onValueChange($event)">
            <ngx-file-drag-drop class="ngx-file_f" emptyPlaceholder="Arrastre o seleccione archivo"  [formControl]="fileControl" (valueChanged)="onValueChange($event)">
            </ngx-file-drag-drop>
        </form> -->

        
        <div class="row borderMdl">
            <div class="col mb-0 mt-2">
                <h6 class="mt-1">
                    <span class="align-middle">Archivos subidos</span>
                </h6>
                <div class="table-responsive text-nowrap">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Archivo</th>
                                <th>Responsable</th>
                                <th>Fecha de Registro</th>
                                <th>Equipo</th>
                            </tr>
                        </thead>
                        <tbody class="table-border-bottom-0">
                            <tr *ngFor="let file of filesSku">
                                <td>{{ file.id }}</td>
                                <td><a href="{{file.archivo}}" target="_blank">{{file.nombre_archivo}}</a></td>
                                <td>{{ file.user }}</td>
                                <td>{{ file.created_at | date : "dd/MM/yyyy hh:mma": "-0000" }}</td>
                                <td><span class="badge {{file.id_rol==3?'bg-info':'bg-warning'}}">{{file.rol}}</span></td>
                            </tr> 
                            <tr *ngIf="filesSku.length == 0" >
                                <td colspan="5" class="text-center">
                                    No se han añadido archivos
                                </td>
                            </tr>
                        </tbody>
                            
                    </table>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
<div class="modal-footer pt-4 d-flex align-items-center gap-2">
    <!-- <button mat-flat-button class="btn bg-success text-white" form="" type="submit" (click)="saveDistributionArt()">Registrar cambios <mat-icon>save</mat-icon></button> -->
    <form [formGroup]="form" class="d-flex align-items-center gap-2 mb-0">
        <input #pdfInput type="file" accept="application/pdf,.pdf" hidden (change)="onFileSelected($event)">
        <button mat-flat-button type="button" (click)="pdfInput.click()"
            class="bg-info text-white d-inline-flex align-items-center ms-2">
            <mat-icon>upload_file</mat-icon>
            Subir nueva versión
        </button>
        <span class="ms-1" *ngIf="form.get('blob')?.value?.length">
            {{ form.get('blob')?.value[0].name }}
        </span>
    </form>
    <button *ngIf="form.get('blob')?.value?.length" [disabled]="uploading" mat-flat-button class="bg-success text-white d-inline-flex align-items-center ms-2" (click)="saveDistributionArt(strategy.id)" >
            <mat-icon>check</mat-icon>
            Confirmar carga
    </button>
    <button  mat-flat-button class="bg-secondary text-white d-inline-flex align-items-center ms-2" mat-dialog-close [style.cursor]="'pointer'">
        <label [style.cursor]="'pointer'">Cerrar</label>
    </button>
</div>



<!-- <div class="modal-footer pt-4">
    <button mat-button (click)="close()">Cancelar<mat-icon>close</mat-icon></button>
    <button mat-flat-button class="btn bg-success text-white" [disabled]="uploading" type="button" (click)="saveDistributionArt()">Registrar cambios <mat-icon>save</mat-icon></button>
</div> -->

<ng-template #uploadProgress>
    <h2 mat-dialog-title class="text-center">{{ confirming ? 'Confirmando archivo...' : 'Subiendo archivo...' }}</h2>
    <mat-dialog-content class="text-center" role="status" aria-live="polite">
        <div class="upload-progress">
            <mat-progress-spinner [diameter]="100" [mode]="usePresignedUpload && !confirming ? 'determinate' : 'indeterminate'" [value]="progress"></mat-progress-spinner>
            <span *ngIf="usePresignedUpload" class="upload-percentage">{{ progress }}%</span>
        </div>
        <p *ngIf="delayed">Esto podría tomar un poco más de tiempo.</p>
        <p>Espera a que termine la carga. No cierres ni recargues la página.</p>
    </mat-dialog-content>
</ng-template>
